import * as moment from 'moment';
import { TimePeriod } from '../../models/enum';
import { momentFormat } from '../../common/constants';

export function getTimeRange(range: { startDate: string | moment.Moment, endDate: string | moment.Moment },
    timeRange: TimePeriod,
    dateFormat: string,
    inProgress: string): string {
    let displayedRange = '';
    if (!dateFormat) {
        dateFormat = momentFormat;
    }
    if (range) {
        switch (timeRange) {
            case TimePeriod.BeginDate:
                displayedRange = moment(range.startDate).format(dateFormat);
                break;
            case TimePeriod.EndDate:
                if (range.endDate) {
                    displayedRange = moment(range.endDate).format(dateFormat);
                } else {
                    displayedRange = inProgress;
                }
                break;
            case TimePeriod.Both:
                if (range.endDate) {
                    displayedRange = `${moment(range.startDate).format(dateFormat)} - ${moment(range.endDate).format(dateFormat)}`;
                } else {
                    displayedRange = `${moment(range.startDate).format(dateFormat)} - ${inProgress}`;
                }
                break;
        }
    }
    return displayedRange;
}